import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { SpacesModule } from './spaces/spaces.module';
import { SpacesRoutingModule } from './spaces/spaces-routing.module';
import { SpacesService } from './services/spaces.service';
import { AboutModule } from './about/about.module';
import { TermsModule } from './terms/terms.module';
import { SpaceModule } from './space/space.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    SpacesRoutingModule,
    SpacesModule,
    AboutModule,
    TermsModule,
    PageNotFoundModule,
    SpaceModule
  ],
  providers: [
    SpacesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts